 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		0: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"4":"component---cache-caches-gatsby-plugin-offline-app-shell-js","5":"component---src-pages-404-mdx","6":"component---src-pages-about-mdx","7":"component---src-pages-accessibility-mdx","8":"component---src-pages-downloads-disbursements-by-month-mdx","9":"component---src-pages-downloads-disbursements-mdx","10":"component---src-pages-downloads-federal-revenue-by-company-mdx","11":"component---src-pages-downloads-index-mdx","12":"component---src-pages-downloads-production-by-disposition-mdx","13":"component---src-pages-downloads-production-by-month-mdx","14":"component---src-pages-downloads-production-mdx","15":"component---src-pages-downloads-revenue-mdx","16":"component---src-pages-explore-index-mdx","17":"component---src-pages-explore-offshore-regions-alaska-mdx","18":"component---src-pages-explore-offshore-regions-atlantic-mdx","19":"component---src-pages-explore-offshore-regions-gulf-mdx","20":"component---src-pages-explore-offshore-regions-pacific-mdx","21":"component---src-pages-explore-states-ak-mdx","22":"component---src-pages-explore-states-al-mdx","23":"component---src-pages-explore-states-ar-mdx","24":"component---src-pages-explore-states-az-mdx","25":"component---src-pages-explore-states-ca-mdx","26":"component---src-pages-explore-states-co-mdx","27":"component---src-pages-explore-states-fl-mdx","28":"component---src-pages-explore-states-id-mdx","29":"component---src-pages-explore-states-il-mdx","30":"component---src-pages-explore-states-in-mdx","31":"component---src-pages-explore-states-ks-mdx","32":"component---src-pages-explore-states-ky-mdx","33":"component---src-pages-explore-states-la-mdx","34":"component---src-pages-explore-states-md-mdx","35":"component---src-pages-explore-states-mi-mdx","36":"component---src-pages-explore-states-mn-mdx","37":"component---src-pages-explore-states-mo-mdx","38":"component---src-pages-explore-states-ms-mdx","39":"component---src-pages-explore-states-mt-mdx","40":"component---src-pages-explore-states-nc-mdx","41":"component---src-pages-explore-states-nd-mdx","42":"component---src-pages-explore-states-ne-mdx","43":"component---src-pages-explore-states-nm-mdx","44":"component---src-pages-explore-states-nv-mdx","45":"component---src-pages-explore-states-ny-mdx","46":"component---src-pages-explore-states-oh-mdx","47":"component---src-pages-explore-states-ok-mdx","48":"component---src-pages-explore-states-or-mdx","49":"component---src-pages-explore-states-pa-mdx","50":"component---src-pages-explore-states-sc-mdx","51":"component---src-pages-explore-states-sd-mdx","52":"component---src-pages-explore-states-tx-mdx","53":"component---src-pages-explore-states-ut-mdx","54":"component---src-pages-explore-states-va-mdx","55":"component---src-pages-explore-states-wa-mdx","56":"component---src-pages-explore-states-wi-mdx","57":"component---src-pages-explore-states-wv-mdx","58":"component---src-pages-explore-states-wy-mdx","59":"component---src-pages-fact-sheet-mdx","60":"component---src-pages-glossary-mdx","61":"component---src-pages-how-revenue-works-aml-reclamation-program-mdx","62":"component---src-pages-how-revenue-works-audits-and-assurances-mdx","63":"component---src-pages-how-revenue-works-coal-excise-tax-mdx","64":"component---src-pages-how-revenue-works-coal-mdx","65":"component---src-pages-how-revenue-works-disbursements-mdx","66":"component---src-pages-how-revenue-works-federal-laws-mdx","67":"component---src-pages-how-revenue-works-federal-reforms-mdx","68":"component---src-pages-how-revenue-works-gomesa-mdx","69":"component---src-pages-how-revenue-works-hpf-mdx","70":"component---src-pages-how-revenue-works-index-mdx","71":"component---src-pages-how-revenue-works-lwcf-mdx","72":"component---src-pages-how-revenue-works-minerals-mdx","73":"component---src-pages-how-revenue-works-native-american-ownership-governance-mdx","74":"component---src-pages-how-revenue-works-native-american-production-mdx","75":"component---src-pages-how-revenue-works-native-american-revenue-mdx","76":"component---src-pages-how-revenue-works-offshore-oil-gas-mdx","77":"component---src-pages-how-revenue-works-offshore-renewables-mdx","78":"component---src-pages-how-revenue-works-onshore-oil-gas-mdx","79":"component---src-pages-how-revenue-works-onshore-renewables-mdx","80":"component---src-pages-how-revenue-works-ownership-mdx","81":"component---src-pages-how-revenue-works-reclamation-mdx","82":"component---src-pages-how-revenue-works-revenues-mdx","83":"component---src-pages-index-mdx","84":"component---src-pages-information-quality-mdx","85":"component---src-pages-patterns-components-index-mdx","86":"component---src-pages-patterns-index-mdx","87":"component---src-pages-patterns-visual-styles-color-mdx","88":"component---src-pages-patterns-visual-styles-iconography-mdx","89":"component---src-pages-patterns-visual-styles-typography-mdx","90":"component---src-pages-plain-language-mdx","91":"component---src-pages-query-data-mdx","92":"component---src-pages-search-results-mdx","93":"component---src-pages-vdp-mdx"}[chunkId]||chunkId) + "-" + {"4":"6ee1700e433cfdf3ee02","5":"db42aa89d20df94a2510","6":"c1883d0ad4c726c21e47","7":"1bbbf581be043565c918","8":"30db99b5e5246f7c536e","9":"2d5e5b55abbbe54d7528","10":"d44ce59c6bfb2b284a60","11":"f48226ff0c2cc9c4dd48","12":"5e7de122effc8dac9320","13":"6e4de666cf92130a2139","14":"23362dbe04628f6fa904","15":"4028e2a445ee11c502ff","16":"67e77beb1422f59a76b3","17":"f4e871c0519228f75532","18":"26517000d4f183ca45c9","19":"9c01637afd5433828742","20":"aee3a5cc0c2613c0ac7e","21":"d9360109a444a6c7b92f","22":"7e241e8f9addc1d72175","23":"f4dbe512bcea26a307d8","24":"36af3d6469d3f2fbd49d","25":"8109fa6d2e852cf91e38","26":"41f556c2e472c93157bf","27":"08d684f44f7f32198c9f","28":"66398f5bb37bbed13bc8","29":"9cb60ef3e1e6c2ce2753","30":"ce674fa14858d95097ed","31":"945ab63b30275e3c9e24","32":"b86872b822ed3a5bed0f","33":"8a9f133d4cc5dbdbad0e","34":"5c704ee8e556fb875a19","35":"453021714316b88c4611","36":"eb979915b45c08f04565","37":"1cda5ee664288174826b","38":"eecd007e0a4999fa6f6b","39":"444a941815881aa85364","40":"536a7b16954ce497b2a3","41":"51c344c1f5e13905b912","42":"8e3af0db1969bf3276ad","43":"0dc80bc7034226396444","44":"0c3840c61a85a931c739","45":"3c1d7a9ee8a2e9a6c822","46":"565d010701b54a44a5e6","47":"9c8336e4f5c9e54e95c4","48":"3c0ce817fea7eec0e1a0","49":"58b6b33412e76de1166c","50":"5bd9942e3abb00b001d2","51":"fac11d7cab9d03ed4df1","52":"1f091ebfdc8436c9f005","53":"e416cee6abda4d2d6c1b","54":"f8f769b46f45153e1dc4","55":"ab1e114ffc339574ee74","56":"9bab8e8108f142136c6d","57":"cd3c4dd55beefa2ad8f3","58":"6dbfcac93ecb55739e90","59":"eab462af30d633921e5d","60":"b26db80edece84e9ca83","61":"25866225e52e09583b8c","62":"bdfd925d24aa39df0fc9","63":"c6257680f946a351154b","64":"2201dfee1431d1cfe4b9","65":"35923c06b47effb8e146","66":"3ca6a60e8f9a04c3b23f","67":"252f30caa230cdc77d88","68":"3129beb87ced1c322a67","69":"5aa3a450629b0f4cb0ef","70":"af438c213fb7877bb88c","71":"b09c499f297ff7ecccba","72":"aea1d81585c04933602b","73":"f172290e81e5f50cc43c","74":"c1161f13496f88f2676d","75":"c9be12f73c6d8c2f5ffb","76":"8e10afdb7ccca9aff719","77":"842f9bc5c37c4be7949b","78":"69ba9d15641aa3f3b19e","79":"9e2a90759c873c8a1fb9","80":"845201eeecc9b1b14667","81":"9e4892cd087b396e57c3","82":"4564f9c67c35c4f0b6e9","83":"27527404b84ef65bd6e5","84":"cfaba7e5ee481cf1b885","85":"d88b980ce12f7026d940","86":"df09c1a52de265c3d8c4","87":"afc4cd73f392209454cb","88":"9c7a573c0cac524fc3fd","89":"2ed1d02e373cc230b9f1","90":"fcdcfa1fd8e39e9c51f6","91":"23362bb8100973d73ad0","92":"012e00ff1042efc51a3d","93":"99684303eb8d317acb9c","98":"e0d57c77c064970fcd05"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/sites/2702-revenue-type-list/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
